/******************************************************************************
 *
 * Copyright (c) 2019-2022 ServiceActivator Inc. All Rights Reserved.
 *
 * Unauthorized copying of the code in this file, completely or partially,
 * via any medium is strictly prohibited.
 *
 * Proprietary and Confidential.
 *
 * Written by 'Shivam Mishra' <shivam.mishra@wakencode.com>, September 2022
 *
 *****************************************************************************/

/**
 * This is a constant margin file, all the margin used in webapp are rest here
 */
export const MARGIN = {
  MARGIN_FOUR: "4px",
  MARGIN_EIGHT: "8px",
  MARGIN_TWELVE: "12px",
  MARGIN_SIXTEEN: "16px",
  MARGIN_TWENTY: "20px",
  MARGIN_TWENTY_FOUR: "24px",
  MARGIN_TWENTY_EIGHT: "28px",
  MARGIN_THIRTY_TWO: "32px",
  MARGIN_THIRTY_SIX: "36px",
  MARGIN_FORTY: "40px",
  MARGIN_FORTY_FOUR: "44px",
  MARGIN_FORTY_EIGHT: "48px",
  MARGIN_FIFTY_TWO: "52px",
  MARGIN_FIFTY_SIX: "56px",
  MARGIN_SIXTY: "60px",
  MARGIN_SIXTY_FOUR: "64px",
  MARGIN_SIXTY_EIGHT: "68px",
  MARGIN_SEVENTY_TWO: "72px",
  MARGIN_SEVENTY_SIX: "76px",
  MARGIN_EIGHTY: "80px",
  MARGIN_EIGHTY_FOUR: "84px",
  MARGIN_EIGHTY_EIGHT: "88px",
  MARGIN_NINETY_TWO: "92px",
  MARGIN_NINETY_SIX: "96px",
  MARGIN_ONE_HUNDRED: "100px",
  MARGIN_ONE_HUNDRED_FOUR: "104px",
  MARGIN_ONE_HUNDRED_EIGHT: "108px",
  MARGIN_ONE_HUNDRED_TWELVE: "112px",
  MARGIN_ONE_HUNDRED_SIXTEEN: "116px",
  MARGIN_ONE_HUNDRED_TWENTY: "120px",
};
